export const LINE_STYLE_PREVIEW_WIDTH = 28;
export const LINE_STYLE_PREVIEW_COMPACT_WIDTH = 18;
export const LINE_STYLE_PREVIEW_HEIGHT = 8;
export const LINE_STYLE_PREVIEW_MARKER_RADIUS = 3;
export const LINE_STYLE_PREVIEW_MAX_STROKE = 5;
export const LINE_STYLE_PREVIEW_DEFAULT_STROKE = 2;
